<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item prop="name">
        <el-input v-model="queryParams.name"  placeholder="通道名称" clearable style="width: 210px" @keyup.enter.native="search" />
      </el-form-item>
      <el-button type="primary" icon="el-icon-search"  @click="search">搜索</el-button>
      <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="handleAdd" v-show="showProduct">新增</el-button>
    </el-form>
    <el-table v-loading="loading" :data="tableData" border>
      <el-table-column type="index" label="序号" align="center"></el-table-column>
      <el-table-column prop="name" label="通道名称" align="center" width="300" :show-overflow-tooltip="true" ></el-table-column>
      <el-table-column prop="parentChannelId" label="父通道名称" align="center"  width="300" :show-overflow-tooltip="true" :formatter="transferCardSourceId" ></el-table-column>
      <el-table-column prop="channelType" label="通道类型" align="center"  width="200" :show-overflow-tooltip="true" :formatter="transferChannelType" ></el-table-column>
      <el-table-column prop="type" label="类型" align="center" min-width="200" max-width="300" :show-overflow-tooltip="true" :formatter="transferType" ></el-table-column>
      <el-table-column prop="status" label="状态" align="center" min-width="150" max-width="300" :show-overflow-tooltip="true" :formatter="transferStatus" ></el-table-column>
      <el-table-column prop="remark" label="备注" align="center" min-width="150" max-width="300" :show-overflow-tooltip="true" :formatter="transferRemark" ></el-table-column>
      <el-table-column label="操作" align="center" class-name="small-padding fixed-width" fixed="right" v-if="showProduct">
        <template v-slot:default="{row}">
          <el-button size="mini" type="text" icon="el-icon-edit" @click="handleEdit(row.id)">编辑</el-button>
          <el-button size="mini" type="text"  icon="el-icon-delete" @click="deleteRow(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="page"
      :limit.sync="pageSize"
      @pagination="initData"
    />
  </div>
</template>


<script>
import { delChannel, listPageChannel } from "@/api/api.js"; //通道分页列表
import { cardSourceSelectList } from "@/api/api.js"; //卡来源列表

export default {
  name: "channelList",
  data() {
    return {
      optSource: [],
      // 查询条件
      queryParams: {
        name:""
      },
      // 遮罩层
      loading: true,
      // 分页器
      page: 1,
      pageSize: 10,
      total: 10,
      // 列表数据
      tableData: [],
    };
  },
  watch: {
			$route(){
				this.search();
			}
	},
  computed: {
    showProduct() {
      const user = this.$store.state.user.user;
      return user.level==0;
    },
  },
  methods: {
    // 添加
    handleAdd() {
      this.$router.push("/card/channelAdd");
    },
    // 编辑
    handleEdit: function(channelId) {
      this.$router.push("/card/channelEdit/" + channelId);
    },
    // 搜索
    handleSearch() {
      this.initData();
    },
    // 获取卡来源
    querySource() {
      cardSourceSelectList({}).then(res => {
        this.optSource = res.data.data;
      });
    },
    // 获取列表
    initData() {
      this.loading=true;
      let params = {
        model:{
          ...this.queryParams
        },
        page: this.page,
        pageSize: this.pageSize,
      };
      listPageChannel(params).then(res => {
        this.loading=false;
        this.tableData = res.data.data.records;
        this.total = res.data.data.total;
      });
    },
    // 通道來源转换
    transferCardSourceId(row) {
      const channelId = Number(row.parentChannelId) === 0 ? row.id : Number(row.parentChannelId)
      let cardSource = this.optSource.filter(item => Number(item.id) === Number(channelId))
      return cardSource[0] && cardSource[0].name;
    },
    // 通道类型
    transferChannelType(row){
      return row.parentChannelId === '0' ? '父通道': '子通道';
    },
    // 类型转换
    transferType(row){
      let obj = {
        "2": "操作网络状态",
        "1": "操作开关机",
      };
      return obj[row.type];
    },
    transferStatus(row){
      let obj = {
        "0": "停用",
        "1": "启用",
      };
     return obj[row.status];
    },
    transferRemark(row){
      return row.remark == null ?"-":row.remark;
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.initData();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.initData();
    },
    // 搜索
    search() {
      this.page = 1,
      this.initData();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.search();
    },
    // 删除
    deleteRow(row) {
      this.$confirm("此操作将永久删除该通道, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let params ={
          id:row.id
        };
        delChannel(params).then(res => {
          if (res.data.code == 200) {
            this.$message({
              type: "success",
              message: "删除通道成功!"
            });
            this.initData();
          }
        });
      }).catch(() => {
        this.$message({
          type: "info",
          message: "已取消删除"
        });
      });
    },
  },
  mounted() {
  },
  created() {
    this.querySource();
    this.initData();
  },
};
</script>
<style scoped lang="less">
.el-button {
  margin-left: 5px;
  border-radius: 3px;
  padding: 10px 20px;
}
</style>
